import { render, staticRenderFns } from "./AnnouncementDetail.vue?vue&type=template&id=0b2def34&scoped=true"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetail.vue?vue&type=style&index=0&id=0b2def34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2def34",
  null
  
)

export default component.exports